import React from 'react';

import BlockAccessPage from '../../../../../components/BlockAccess/BlockAccessPage';
import {checkIfHasPermissions} from '../../../../../components/Menu/Utils/commonFunctions';
import Tabs from '../../../../../components/Tabs/Tabs';
import {PermissionEnum} from '../../../../../constants/permissionsEnum';
import TranslatedText from '../../../../../libraries/I18N/TranslatedText';
import {accessModule} from '../../../../../store/companyStore/companyDetailsStore';
import {shouldBlockModuleAccess} from '../../../../../utils/SubscriptionHelper';

import DownStream from './DownStream';
import Upstream from './Upstream';

const SupplyChain: React.FC<{
  selectedYear: string;
  facilityId: string;
}> = ({selectedYear, facilityId}) => {
  const SCTab = [
    {
      id: 'upstream',
      name: <TranslatedText translationKey="Upstream" />,
      component: shouldBlockModuleAccess(accessModule.scope3) ? (
        <BlockAccessPage />
      ) : (
        <Upstream facilityId={facilityId} selectedYear={selectedYear} />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerSupplyChainUpstream
      )
    },
    {
      id: 'downstream',
      name: <TranslatedText translationKey="Downstream" />,
      component: shouldBlockModuleAccess(accessModule.scope3) ? (
        <BlockAccessPage />
      ) : (
        <DownStream facilityId={facilityId} selectedYear={selectedYear} />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerSupplyChainDownstream
      )
    }
  ].filter((item) => !item.hidden);

  return (
    <div>
      <Tabs array={SCTab} type="card" />
    </div>
  );
};

export default SupplyChain;
